<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/usage-rating/rateplan" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.ViewUsageRatePlan") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row">
      <vx-card title no-shadow card-border>
        <!-- <div class="vx-row"> -->
        <!-- <div class="overflow-x-auto"> -->
        <!-- <div class="vx-row">
          <div class="vx-col w-full md:w-full lg:w-full">
            <ul class="horizontal-sm-btn flex mb-2 float-right">
              <li>
                <div
                  class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                >
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-edit-2"
                    class="truncate"
                    @click="editData(id)"
                    size="small"
                    >{{ $t("setup.label.Edit") }}</vs-button
                  >
                </div>
              </li>
            </ul>
          </div>
        </div> -->
        <table
          style="width: 100rem"
          class="table w-full table-bordered table-striped"
        >
          <tr>
            <td>
              <b>{{ $t("setup.label.PlanName") }}</b>
            </td>
            <td>{{ viewusage.planDesc }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.ProductName") }}</b>
            </td>
            <td>{{ viewusage.productDesc }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.ChargeCode") }}</b>
            </td>
            <td>{{ viewusage.chargeCode }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.RUM") }}</b>
            </td>
            <td>{{ viewusage.rumName }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.RatingType") }}</b>
            </td>
            <td>{{ viewusage.ratingType }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.TimeModel") }}</b>
            </td>
            <td>{{ viewusage.timeModelName }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.ZoneModel") }}</b>
            </td>
            <td>{{ viewusage.zoneType }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t("setup.label.RatePlanName") }}</b>
            </td>
            <td>{{ viewusage.ratePlanName }}</td>
          </tr>
        </table>
        <div>
          <vs-button
            v-if="viewusage.ratingType !== 'Continous'"
            class="mb-4 footerButton-nextusage"
            style="margin-left: 40%"
            @click="editJobsPopup = true"
            >{{ $t("setup.label.ViewQuantityTier") }}</vs-button
          >
        </div>
        <div v-if="viewusagebalance.length">
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>
                {{ $t("setup.label.ListofTimePeriods") }}
              </h4>
            </div>
          </div>

          <div class="vx-row mt-6">
            <div class="vx-col w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.StartYear") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.EndYear") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.StartMonth") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.EndMonth") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.StartDay") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.EndDay") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.StartTime") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.EndTime") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Action") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(timemodels, index) in viewusagebalance.slice(0, 1)"
                    :key="index"
                  >
                    <td>{{ timemodels.startYear }}</td>
                    <td>{{ timemodels.endYear }}</td>
                    <td>{{ timemodels.startMonth }}</td>
                    <td>{{ timemodels.endMonth }}</td>
                    <td>{{ timemodels.startDay }}</td>
                    <td>{{ timemodels.endDay }}</td>
                    <td>{{ timemodels.startTime }}</td>
                    <td>{{ timemodels.endTime }}</td>
                    <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        title="View"
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current text-primary"
                        @click="
                          $router.push({
                            name: 'Usage Rate',
                            params: {
                              id: timemodels.rateplanId,
                              timePeriodId: timemodels.timePeriodId,
                              data: viewusage,
                            },
                          })
                        "
                        class="ml-4 icon_row"
                      />
                    </vs-td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('setup.label.EditQuantityTier')"
        :active.sync="changePlanPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.TierName')"
                v-model="quantityTireData.tierName"
                class="w-full mb-2 font-semibold"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-1 font-semibold"
                  >{{ $t("setup.label.CumulativeResource") }}
                  <span class="required"> *</span></small
                >
                <v-select
                  label="name"
                  :options="ReportsData.currencyDatas"
                  v-model="quantityTireData.resourceName"
                  :reduce="(obj) => obj.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mt-1 mb-2"
                >
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-1/4">
              <vs-input
                :label="$t('setup.label.StepName')"
                v-model="Reports.stepName"
                class="w-full mb-2 font-semibold starlabel"
              />
            </div>
            <div class="vx-col w-1/4">
              <vs-input
                :label="$t('setup.label.StartRange')"
                v-model="Reports.startRange"
                class="w-full mb-2 font-semibold starlabel"
              />
            </div>
            <div class="vx-col w-1/4">
              <vs-input
                :label="$t('setup.label.EndRange')"
                v-model="Reports.endRange"
                class="w-full mb-2 font-semibold starlabel"
              />
            </div>
            <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                icon-pack="feather"
                icon="icon-plus"
                :title="$t('setup.label.Add')"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-6">
            <vs-table
              v-if="
                quantityTireData.stepsDetailData &&
                quantityTireData.stepsDetailData.length
              "
              :data="Reports.editDatas"
              class="w-full"
            >
              <template slot="thead">
                <vs-th colspan="12">
                  <div class="vx-row w-full">
                    <div class="vx-col w-full md:w-11/12">
                      <div class="vx-row w-full">
                        <div class="vx-col w-full md:w-1/3">
                          {{ $t("setup.label.StepName") }}
                        </div>
                        <div class="vx-col w-full md:w-1/3">
                          <!-- <div class="ml-6"> -->
                          {{ $t("setup.label.StartRange") }}
                          <!-- </div> -->
                        </div>
                        <div class="vx-col w-full md:w-1/3">
                          <!-- <div class="ml-6"> -->
                          {{ $t("setup.label.EndRange") }}
                          <!-- </div> -->
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/12">
                      {{ $t("setup.label.Action") }}
                    </div>
                  </div>
                </vs-th>
              </template>
              <template>
                <vs-tr>
                  <vs-td colspan="12">
                    <div
                      class="vx-row w-full pb-2 pt-2"
                      v-for="(n, i) in Reports.editDatas"
                      :key="i"
                    >
                      <div class="vx-col w-full md:w-11/12">
                        <div class="vx-row">
                          <div class="vx-col w-full md:w-1/3">
                            <vs-input
                              v-model="Reports.editDatas[i].stepName"
                              :placeholder="$t('setup.label.StepName')"
                              style="width: 100%"
                              class="mb-2 font-semibold"
                            />
                          </div>
                          <div class="vx-col w-full md:w-1/3">
                            <vs-input
                              :placeholder="$t('setup.label.StartRange')"
                              v-model="Reports.editDatas[i].startRange"
                              style="width: 100%"
                              class="mb-2 font-semibold"
                            />
                          </div>
                          <div class="vx-col w-full md:w-1/3">
                            <vs-input
                              :placeholder="$t('setup.label.EndRange')"
                              v-model="Reports.editDatas[i].endRange"
                              style="width: 100%"
                              class="mb-2 font-semibold"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-full md:w-1/12">
                        <vs-button
                          v-if="n == Reports.editDatas.length"
                          color="success"
                          icon-pack="feather"
                          icon="icon-plus"
                          class="mt-5"
                          type="border"
                          :title="$t('setup.label.Add')"
                          size="small"
                          style="border-radius: 50%"
                          @click="addItem(i)"
                        ></vs-button>
                        <vs-button
                          v-else
                          color="warning"
                          icon-pack="feather"
                          icon="icon-x"
                          class="mt-5"
                          type="border"
                          size="small"
                          style="border-radius: 50%"
                          @click="removeItem(i)"
                        ></vs-button>
                      </div>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div class="center mt-2 mb-2">
            <span class="ml-1 mr-1">
              <vs-button
                @click="changePlanFunc"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('setup.label.QuantityTier')"
        classContent="popup-example"
        :active.sync="editJobsPopup"
      >
        <form>
          <div class="vx-row">
            <div style="margin-left: 30px">
              <vs-button
                style="margin-left: 42rem; margin-top: 10px"
                color="primary"
                icon-pack="feather"
                icon="icon-edit-2"
                class="truncate"
                @click="changePlanPopup = true"
                size="small"
                >{{ $t("setup.label.Edit") }}</vs-button
              >
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.TierName')"
                    v-model="quantityTireData.tierName"
                    class="w-full mb-2 font-semibold"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label mt-1 font-semibold"
                      >{{ $t("setup.label.CumulativeResource") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="name"
                      :options="ReportsData.currencyDatas"
                      v-model="quantityTireData.resourceName"
                      :reduce="(obj) => obj.id"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mt-1 mb-2"
                    >
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="vx-row mt-4"></div>
              <div class="vx-row mt-6">
                <div>
                  <vs-table
                    v-if="
                      quantityTireData.stepsDetailData &&
                      quantityTireData.stepsDetailData.length
                    "
                    style="width: 660px"
                    class="ml-3 mr-2 vx-row w-100"
                    :data="quantityTireData.stepsDetailData"
                  >
                    <template slot="thead">
                      <vs-th>{{ $t("setup.label.StepName") }}</vs-th>
                      <vs-th>{{ $t("setup.label.StartRange") }}</vs-th>
                      <vs-th>{{ $t("setup.label.EndRange") }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="quantityTire"
                        v-for="(
                          quantityTire, index
                        ) in quantityTireData.stepsDetailData"
                      >
                        <vs-td :data="quantityTire.stepName">{{
                          quantityTire.stepName
                        }}</vs-td>
                        <vs-td :data="quantityTire.startRange">{{
                          quantityTire.startRange
                        }}</vs-td>
                        <vs-td :data="quantityTire.endRange">
                          {{ quantityTire.endRange }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";

const ReportsEmptyObj = {
  planDesc: "",
  product: "",
  charge: "",
  rumName: "",
  eventRecordType: "",
  timeModelName: "",
  zoneType: "",
  ratePlanName: "",
  editDatas: [
    {
      stepName: "",
      startRange: "",
      endRange: "",
    },
  ],
  resourceId: "",
  name: "",
  tierId: "",
  stepId: "",
  tierName: "",
  resourceName: "",

  usageRateplanId: "",
};
const priceEmptyObj = {
  chargeCode: "",
  chargeOwner: "",
  chargevariant: "",
  currencyId: "",
  discountId: "",
  isPrepaid: "",
  locale: "en",
  planCode: "",
  price: "",
  priceregion: "",
  productId: "",
  duration: "",
  roundingType: "",
  glId: "",
  impact: "",
  uom: "",
  rum: "",
  unit: "",
};
export default {
  data() {
    return {
      viewusage: {},
      viewusagebalance: {},
      timeList: [],
      priceList: [],
      editDatas: [
        {
          stepName: "",
          startRange: "",
          endRange: "",
        },
      ],
      Reports: ReportsEmptyObj,
      warningPopup: false,
      warningText: "",
      editPopupYear: false,
      editJobsPopup: false,
      changePlanPopup: false,
      errorMessage: "",
      price: priceEmptyObj,
      createPriceArray: [],
      editPriceArray: [],
      editPrice: { ...priceEmptyObj },
      priceTemplateData: {},
      prepaid: false,
      currencyCode: "",
      id: "",
      idPrice: "",
      pricingData: [],
      planData: [],
      productOptions: [],
      chargeCodes: [],
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.usageRating.GetUsageTemplate,
      quantityTireData: (state) => state.usageRating.quantityTireData,
      viewusagedetails: (state) => state.usageRating.viewusagerating,
      rateplancreate: (state) => state.usageRating.rateplancreate,
      viewusagebalancedetails: (state) =>
        state.usageRating.viewusageratingbalance,
    }),
  },
  methods: {
    async getPlanTemplate() {
      try {
        await this.$store.dispatch("usageRating/setviewUsage", this.id);
        this.viewusage = this.viewusagedetails;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanBalance() {
      try {
        await this.$store.dispatch(
          "usageRating/setviewUsageRateBalance",
          this.id
        );
        this.viewusagebalance = this.viewusagebalancedetails;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    removeItem(i) {
      this.Reports.editDatas.splice(i, 1);
    },
    addItem() {
      this.Reports.editDatas = [...this.Reports.editDatas];
    },
    addParameter() {
      console.log("helllo", this.Reports.editDatas);
      try {
        let crateParameter = {
          stepName: this.Reports.stepName,
          startRange: this.Reports.startRange,
          endRange: this.Reports.endRange,
        };

        this.Reports.editDatas = [...this.Reports.editDatas, crateParameter];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async changePlanFunc() {
      let payload = {
        steps: this.Reports.editDatas,
        range: [
          {
            tierName: this.quantityTireData.tierName,
          },
        ],
        resourceId: this.quantityTireData.resourceId,
      };
      await this.$store.dispatch(
        "usageRating/updateQuantitytierElement",
        this.quantityTireData.tierId,
        payload
      );
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Quantity Tier Edited Successfully!",
        type: "success",
      });
      this.changePlanPopup = false;
      this.editJobsPopup = false;
    },
  },
  watch: {},
  created() {},
  async mounted() {
    this.quantityTireData = {};
    this.id = this.$route.params.id;
    this.getPlanTemplate();
    this.getPlanBalance();
    await this.$store.dispatch("usageRating/quantityTireAction", this.id);
    this.Reports.editDatas = this.quantityTireData.stepsDetailData;
  },
};
</script>
<style lang="scss">
.mid-popup .vs-popup {
  width: 1000px;
  max-width: 100%;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.popup-example table td {
  vertical-align: middle;
}
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  /* width: 100px; */
  font-size: 14px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 60px;
  font-size: 14px;
}
.price-table >>> .vs-table-text {
  display: block !important;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
.footerButton-nextusage {
  width: 212px;
  height: 38px;
  top: 18px;
}
.w-13 {
  width: 13%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 5%;
  }
}
.vs__selected-options {
  overflow: hidden;
}
.normal-table tr {
  td {
    &:not(:last-child) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
    border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  }

  text-align: center;
}
</style>
